import { render, staticRenderFns } from "./relevanceDevicesDialog.vue?vue&type=template&id=2c25fd60&scoped=true"
import script from "./relevanceDevicesDialog.vue?vue&type=script&lang=js"
export * from "./relevanceDevicesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c25fd60",
  null
  
)

export default component.exports